export const City_Data = [
  { id: 1, locality: "Patia", count: 533 },
  { id: 2, locality: "Chandrasekharpur", count: 261 },
  { id: 3, locality: "Sahid Nagar", count: 192 },
  { id: 4, locality: "Jayadev Vihar", count: 96 },
  { id: 5, locality: "Nayapalli", count: 138 },
  { id: 6, locality: "Kharabela Nagar", count: 141 },
  { id: 7, locality: "Unit 4", count: 73 },
  { id: 8, locality: "Lakshmi Sagar", count: 128 },
];

export const Accordion_Data = [
  {
    id: 1,
    title: "Popular cuisines near me",
    list: [
      "Bakery food near me",
      "Beverages food near me",
      "Biryani food near me",
      "Burger food near me",
      "Chinese food near me",
      "Continental food near me",
      "Desserts food near me",
      "Kebab food near me",
      "Momos food near me",
      "Mughlai food near me",
      "North Indian food near me",
      "Odia food near me",
      "Pizza food near me",
      "Rolls food near me",
      "Sandwich food near me",
      "Seafood food near me",
      "Shake food near me",
      "Sichuan food near me",
      "South Indian food near me",
      "Street food near me",
    ],
  },
  {
    id: 2,
    title: "Popular restaurant types near me",
    list: [
      "Bakeries near me ",
      "Bars near me",
      "Beverage Shops near me",
      "Bhojanalya near me",
      "Cafés near me",
      "Casual Dining near me",
      "Clubs near me",
      "Dessert Parlors near me",
      "Dhabas near me",
      "Fine Dining near me",
      "Food Courts near me",
      "Food Trucks near me",
      "Kiosks near me",
      "Lounges near me",
      "Microbreweries near me",
      "Paan Shop near me",
      "Pubs near me",
      "Quick Bites near me",
      "Sweet Shops near me",
    ],
  },
  {
    id: 3,
    title: "Cities We Deliver To",
    list: [
      "Delhi NCR",
      "Kolkata",
      "Mumbai",
      "Bengaluru",
      "Pune",
      "Hyderabad",
      "Chennai",
      "Lucknow",
      "Kochi",
      "Jaipur",
      "Ahmedabad",
      "Chandigarh",
      "Goa",
      "Indore",
      "Gangtok",
      "Nashik",
      "Ooty",
      "Shimla",
      "Ludhiana",
      "Guwahati",
      "Amritsar",
      "Kanpur",
      "Allahabad",
      "Aurangabad",
      "Bhopal",
      "Ranchi",
      "Visakhapatnam",
      "Bhubaneswar",
      "Coimbatore",
      "Mangalore",
      "Vadodara",
      "Nagpur",
      "Agra",
      "Dehradun",
      "Mysore",
      "Puducherry",
      "Surat",
      "Varanasi",
      "Patna",
      "Udaipur",
      "Khajuraho",
      "Neemrana",
      "Cuttack",
      "Trivandrum",
      "Haridwar",
      "Leh",
      "Pushkar",
      "Rajkot",
      "Madurai",
      "Kozhikode",
      "Alappuzha",
      "Thrissur",
      "Manipal",
      "Vijayawada",
      "Jodhpur",
      "Kota",
      "Ajmer",
      "Mussoorie",
      "Rishikesh",
      "Jalandhar",
      "Jammu",
      "Manali",
      "Dharamshala",
      "Raipur",
      "See more",
    ],
  },
];
